module.exports = __webpack_public_path__ + "img/logo.d607fbe0.jpg";